// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DollarTwoToneSvg from "@fishx/icons-svg/es/asn/DollarTwoTone";
import FishxIcon from '../components/FishxIcon';

var DollarTwoTone = function DollarTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DollarTwoToneSvg
  }));
};

DollarTwoTone.displayName = 'DollarTwoTone';
export default React.forwardRef(DollarTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DollarTwoTone.js
// module id = 2441
// module chunks = 0